import React from 'react'
import ProjectDetails from '../Layout/Project/details'

const ProjectDetailsPage = () => {
  return <ProjectDetails />
}

export default ProjectDetailsPage
